import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import iconYellow from 'src/assets/image/icon-alert-yellow.svg';

import { RecipientGroupsProps } from '../../../../../types/globalSetting';

export const ApplyConfirmModal = React.memo(
  (props: {
    data: RecipientGroupsProps | undefined;
    onClose: () => void;
    visible: boolean;
    onConfirm: () => void;
  }) => {
    const { t } = useTranslation();
    const onConfirm = async () => {
      props.onConfirm();
    };
    return (
      <Modal
        closeOnEsc
        closeOnOutsideClick
        isClosable
        isOpen={props.visible}
        onClose={props.onClose}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {/*{props.data?.isDefault*/}
            {/*  ? props.data?.type === RecipientGroupType.POLICY*/}
            {/*    ? t(*/}
            {/*        'globalSetting.recipientGroup.defaultGroup.policyNotification.name'*/}
            {/*      )*/}
            {/*    : t(*/}
            {/*        'globalSetting.recipientGroup.defaultGroup.systemNotification.name'*/}
            {/*      )*/}
            {/*  : props.data?.recipientGroupName}*/}
          </ModalHeader>
          <ModalBody>
            <Flex p="1px" pb={0} pr={0} m="23px 0px">
              <Box flex={1}>
                <Image src={iconYellow} alt="logo" width="12x" height="12x" />
              </Box>
              <Box flex={5}>
                <Text fontWeight={400} lineHeight="sm">
                  {t(
                    'globalSetting.recipientGroup.alertModal.applyToPolices.content'
                  )}
                </Text>
                <br />
                <Text fontWeight={400} lineHeight="sm">
                  {t(
                    'globalSetting.recipientGroup.alertModal.applyToPolices.content2'
                  )}
                </Text>
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button variant="primary" minWidth="20x" onClick={onConfirm}>
              {t('common.button.apply')}
            </Button>
            <Space width="2x" />
            <Button minWidth="20x" onClick={props.onClose}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
);
